var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shared-pricing',{staticClass:"in-person-details"},[_c('travel-info',{staticClass:"in-person-details__travel-info"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }